"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.beforeEachContext = exports.partialMock = exports.asMockModule = exports.asMock = void 0;
function asMock(fn) {
    return fn;
}
exports.asMock = asMock;
function asMockModule(module) {
    return module;
}
exports.asMockModule = asMockModule;
function partialMock(obj = {}) {
    return obj;
}
exports.partialMock = partialMock;
function beforeEachContext(factory) {
    let base = factory();
    beforeEach(() => {
        base = factory();
    });
    const out = partialMock({});
    Object.keys(base).forEach((key) => {
        Object.defineProperty(out, key, {
            get: function () {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                return base[key];
            },
        });
    });
    return out;
}
exports.beforeEachContext = beforeEachContext;
